import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export const conversionColumns = parentProperty => [bingadsGridColumn({
  name: 'ConversionRate',
  property: `${parentProperty}ConversionRate`,
  title: i18n.getString('HotelCenter_Overview_Grid_ConversionRate_Label'),
  type: 'number',
  format: 'percentage-value',
  sortable: true,
}), bingadsGridColumn({
  name: 'Conversions',
  property: `${parentProperty}Conversions`,
  title: i18n.getString('HotelCenter_Overview_Grid_Conversions_Label'),
  type: 'number',
  format: 'integer',
  sortable: true,
}), bingadsGridColumn({
  name: 'CPA',
  property: `${parentProperty}CPA`,
  title: i18n.getString('HotelCenter_Overview_Grid_CPA_Label'),
  type: 'number',
  sortable: true,
}), bingadsGridColumn({
  name: 'GrossRevenue',
  property: `${parentProperty}GrossRevenue`,
  title: i18n.getString('HotelCenter_Overview_Grid_GrossRevenue_Label'),
  type: 'number',
  sortable: true,
}), bingadsGridColumn({
  name: 'GrossRevenuePerClick',
  property: `${parentProperty}GrossRevenuePerClick`,
  sortable: true,
  type: 'number',
  title: i18n.getString('HotelCenter_Overview_Grid_GrossRevenuePerClick_Label'),
}), bingadsGridColumn({
  name: 'GrossRevenuePerConv',
  property: `${parentProperty}GrossRevenuePerConv`,
  sortable: true,
  type: 'number',
  title: i18n.getString('HotelCenter_Overview_Grid_GrossRevenuePerConv_Label'),
}), bingadsGridColumn({
  name: 'GrossROAS',
  property: `${parentProperty}GrossROAS`,
  sortable: true,
  type: 'number',
  format: 'percentage-value',
  title: i18n.getString('HotelCenter_Overview_Grid_GrossROAS_Label'),
}), bingadsGridColumn({
  name: 'NetRevenue',
  property: `${parentProperty}NetRevenue`,
  title: i18n.getString('HotelCenter_Overview_Grid_NetRevenue_Label'),
  type: 'number',
  sortable: true,
}), bingadsGridColumn({
  name: 'NetRevenuePerClick',
  property: `${parentProperty}NetRevenuePerClick`,
  sortable: true,
  type: 'number',
  title: i18n.getString('HotelCenter_Overview_Grid_NetRevenuePerClick_Label'),
}), bingadsGridColumn({
  name: 'NetRevenueConv',
  property: `${parentProperty}NetRevenueConv`,
  sortable: true,
  type: 'number',
  title: i18n.getString('HotelCenter_Overview_Grid_NetRevenueConv_Label'),
}), bingadsGridColumn({
  name: 'NetROAS',
  property: `${parentProperty}NetROAS`,
  sortable: true,
  type: 'number',
  format: 'percentage-value',
  title: i18n.getString('HotelCenter_Overview_Grid_NetROAS_Label'),
}), bingadsGridColumn({
  name: 'TotalBookedNights',
  property: `${parentProperty}TotalBookedNights`,
  title: i18n.getString('HotelCenter_Overview_Grid_TotalBookedNights_Label'),
  type: 'number',
  format: 'integer',
  sortable: true,
}), bingadsGridColumn({
  name: 'AvgBookedABW',
  property: `${parentProperty}AvgBookedABW`,
  title: i18n.getString('HotelCenter_Overview_Grid_AvgBookedABW_Label'),
  type: 'number',
  sortable: true,
}), bingadsGridColumn({
  name: 'AvgBookedNights',
  property: `${parentProperty}AvgBookedNights`,
  title: i18n.getString('HotelCenter_Overview_Grid_AvgBookedNights_Label'),
  type: 'number',
  sortable: true,
}), bingadsGridColumn({
  name: 'BookedABW',
  property: `${parentProperty}BookedABW`,
  title: i18n.getString('HotelCenter_Overview_Grid_BookedABW_Label'),
  type: 'number',
  format: 'integer',
  sortable: true,
})];

export const conversionColumnList = ['Conversions', 'ConversionRate', 'CPA', 'GrossRevenue', 'GrossRevenuePerClick',
  'GrossRevenuePerConv', 'GrossROAS', 'NetRevenue', 'NetRevenuePerClick', 'NetRevenueConv', 'NetROAS', 'TotalBookedNights',
  'AvgBookedABW', 'BookedABW', 'AvgBookedNights'];

export const conversionFilterReWriteMap = parentProperty => ({
  [`${parentProperty}Conversions`]: i18n.getString('HotelCenter_Overview_Grid_Conversions_Label'),
  [`${parentProperty}ConversionRate`]: i18n.getString('HotelCenter_Overview_Grid_ConversionRate_Label'),
  [`${parentProperty}CPA`]: i18n.getString('HotelCenter_Overview_Grid_CPA_Label'),
  [`${parentProperty}GrossRevenue`]: i18n.getString('HotelCenter_Overview_Grid_GrossRevenue_Label'),
  [`${parentProperty}GrossRevenuePerClick`]: i18n.getString('HotelCenter_Overview_Grid_GrossRevenuePerClick_Label'),
  [`${parentProperty}GrossRevenuePerConv`]: i18n.getString('HotelCenter_Overview_Grid_GrossRevenuePerConv_Label'),
  [`${parentProperty}GrossROAS`]: i18n.getString('HotelCenter_Overview_Grid_GrossROAS_Label'),
  [`${parentProperty}NetRevenue`]: i18n.getString('HotelCenter_Overview_Grid_NetRevenue_Label'),
  [`${parentProperty}NetRevenuePerClick`]: i18n.getString('HotelCenter_Overview_Grid_NetRevenuePerClick_Label'),
  [`${parentProperty}NetRevenueConv`]: i18n.getString('HotelCenter_Overview_Grid_NetRevenueConv_Label'),
  [`${parentProperty}NetROAS`]: i18n.getString('HotelCenter_Overview_Grid_NetROAS_Label'),
  [`${parentProperty}TotalBookedNights`]: i18n.getString('HotelCenter_Overview_Grid_TotalBookedNights_Label'),
  [`${parentProperty}AvgBookedABW`]: i18n.getString('HotelCenter_Overview_Grid_AvgBookedABW_Label'),
  [`${parentProperty}BookedABW`]: i18n.getString('HotelCenter_Overview_Grid_BookedABW_Label'),
  [`${parentProperty}AvgBookedNights`]: i18n.getString('HotelCenter_Overview_Grid_AvgBookedNights_Label'),
});
